<template>
  <div class="border border-gray-200 rounded p-6 flex items-center justify-between">
    <div class="flex-grow">
      <header class="font-bold text-gray-900 flex items-center gap-3">
        <span>{{ task.name }}</span>
        <UserTaskProductAreaBadge :product-area="task.product_area" />
        <TaskDueDateBadge :task="task" />
      </header>
      <p v-if="task.context_type === 'Contact' && task.context?.name" class="mt-1 text-sm text-gray-500">
        {{ task.context?.name }}
      </p>
    </div>
    <TButton v-if="task.status === 'completed'" color="indigo" label="Completed" :disabled="true" />
    <router-link v-if="showButton" :to="`/tasks/${task.id}`"><TButton color="indigo" label="Start" /></router-link>
  </div>
</template>

<script>
import UserTaskProductAreaBadge from './UserTaskProductAreaBadge.vue';
import TaskDueDateBadge from './TaskDueDateBadge.vue';
import TButton from '../shared/TButton.vue';

export default {
  components: {
    UserTaskProductAreaBadge,
    TaskDueDateBadge,
    TButton,
  },
  props: {
    task: {
      type: Object,
      required: true,
    },
    showButton: {
      type: Boolean,
      require: false,
      default: true,
    },
  },
};
</script>
